import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { ContentSneakPeek, getAllSneakPeeks, getStartWatchingList } from '@/services/ProjectsService'
import { mapStartWatchingToContentLinks } from '@/services/RenderService/mapCollectionDataSources'
import { LinkViewModel, MapDataOptions } from '@/services/RenderService/types'

export async function getStartWatchingEpisodes(options?: MapDataOptions): Promise<LinkViewModel[]> {
  const projects = await getStartWatchingList()
  return mapStartWatchingToContentLinks(projects, options)
}

export async function getSneakPeekEpisodes(client: ApolloClient<NormalizedCacheObject>): Promise<ContentSneakPeek[]> {
  const sneakPeekCollection = await getAllSneakPeeks(client)
  return sneakPeekCollection.map((item) => ({
    ...item,
    __typename: 'ContentSneakPeek',
  }))
}
